// frontend/src/utils/printService.js
import moment from 'moment-timezone';
import { cashierContext } from '../context/CashierContext.js';
import { Notification } from '../components/Notification.js';

const VENEZUELA_TIMEZONE = 'America/Caracas';

/**
 * 🛠️ ENRUTADOR DE IMPRESIÓN (HYBRID PRINT)
 * Protege la lógica original de escritorio y aplica soluciones seguras para móvil.
 */
/**
 * 🛠️ ENRUTADOR DE IMPRESIÓN (HYBRID PRINT) CORREGIDO
 * Protege la lógica original de escritorio y aplica Iframe seguro para móvil.
 */
const executeHybridPrint = (htmlContent) => {
    // Detectamos si es un dispositivo móvil o una pantalla pequeña
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.matchMedia('(max-width: 1024px)').matches;

    if (isMobile) {
        // ==========================================
        // 📱 LÓGICA MÓVIL (Iframe Seguro)
        // ==========================================
        const iframe = document.createElement('iframe');
        iframe.style.position = 'fixed';
        iframe.style.right = '-9999px';
        iframe.style.bottom = '-9999px';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.border = '0';
        document.body.appendChild(iframe);

        // Escritura segura cross-browser
        const doc = iframe.contentDocument || iframe.contentWindow.document;
        doc.open();
        doc.write(htmlContent);
        doc.close();

        // Esperar a que renderice y lanzar impresión nativa
        setTimeout(() => {
            try {
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
            } catch (err) {
                console.error("Error imprimiendo iframe:", err);
            }
            
            // Destruir el iframe después de 5 minutos para no cortar el spooler
            setTimeout(() => {
                if (document.body.contains(iframe)) {
                    document.body.removeChild(iframe);
                }
            }, 300000); 
        }, 500);

    } else {
        // ==========================================
        // 💻 LÓGICA DE ESCRITORIO (ORIGINAL INTACTA)
        // ==========================================
        const printWindow = window.open('', '_blank', 'width=350,height=500,resizable=yes,scrollbars=yes');
        if (!printWindow) {
            // Intentamos mostrar notificación, si no existe el contenedor no rompe la app
            try {
                const notifContainer = document.querySelector('.notification-container');
                if (notifContainer) Notification(notifContainer, 'Permita las ventanas emergentes.', 'warning');
            } catch(e) {}
            return;
        }

        // Inyectamos el script original de cierre automático
        const desktopHtml = htmlContent.replace('</body>', `
            <script>
                window.onload = () => {
                    setTimeout(() => {
                        window.print();
                        // Fallback seguro para --kiosk-printing
                        setTimeout(() => window.close(), 50);
                    }, 500);
                };
                window.onafterprint = () => window.close();
            </script>
        </body>`);

        printWindow.document.write(desktopHtml);
        printWindow.document.close();
    }
};


/**
 * 1. IMPRESIÓN DE TICKET DE VENTA
 */
export const printTicketReceipt = async (ticketDetails) => {
    if (!ticketDetails || (!ticketDetails.ticket_code && !ticketDetails.id)) {
        Notification(document.querySelector('.notification-container') || document.body, 'Error: No se pudo generar el recibo.', 'error');
        return;
    }

    const state = cashierContext.state;
    const currencySymbol = state.availableCurrencies.find(c => c.code === ticketDetails.currency)?.symbol || '$';
    const formattedDate = moment.utc(ticketDetails.created_at).tz(VENEZUELA_TIMEZONE).format('DD/MM/YYYY');
    const formattedTime = moment.utc(ticketDetails.created_at).tz(VENEZUELA_TIMEZONE).format('hh:mm A');

    let caballosImpresion = 'N/A';
    if (ticketDetails.selected_horse_names && ticketDetails.selected_horse_names.length > 0) {
        if (ticketDetails.bet_type_name === 'Mixto') {
            caballosImpresion = ticketDetails.selected_horse_names.map(h => `<br> * ${h}`).join('');
        } else {
            caballosImpresion = ticketDetails.selected_horse_names.join(', ');
        }
    }

    const receiptHtmlContent = `
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="utf-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Ticket</title>
            <style>
                /* ESTÁNDAR 58mm PARA IMPRESORAS TÉRMICAS TIPO POS-5890K */
                @page { margin: 0; size: 58mm auto; }
                html, body { 
                    margin: 0 !important; 
                    padding: 0 !important; 
                    background: #fff;
                    width: 100%;
                }
                .thermal-ticket {
                    font-family: 'Courier New', Courier, monospace;
                    font-size: 11px;
                    font-weight: 900 !important; 
                    color: #000;
                    width: 58mm;
                    max-width: 100%;
                    margin: 0 auto;
                    padding: 2mm 2mm 15mm 2mm; 
                    box-sizing: border-box;
                    line-height: 1.2;
                    text-align: left;
                    overflow: hidden;
                }
                .thermal-ticket * { font-weight: 900 !important; }
            </style>
        </head>
        <body>
            <div class="thermal-ticket">
                ${formattedDate} - ${formattedTime}<br>
                ========================<br>
                TICKET:${ticketDetails.id}<br>
                ========================<br>
                HIPODROMO: ${ticketDetails.track_name || 'N/A'}<br>
                CARRERA: C-${ticketDetails.race_number || 'N/A'}<br>
                APUESTA: ${ticketDetails.bet_type_name || 'N/A'}<br>
                EJEMPLAR ${caballosImpresion}<br>
                JUGADA:${currencySymbol}${parseFloat(ticketDetails.amount).toFixed(2)} ${ticketDetails.currency || 'USD'}<br>
                ========================<br>
                Valido por 3 dias<br>
                <br><br><br><br>
                . . . . . . . . . . . .
            </div>
        </body>
        </html>
    `;

    executeHybridPrint(receiptHtmlContent);
};

/**
 * 2. IMPRESIÓN DE COMPROBANTE DE PAGO DE PREMIO
 */
export const printPayoutReceipt = async (ticketDetails) => {
    if (!ticketDetails || (!ticketDetails.ticket_code && !ticketDetails.id)) {
        return;
    }

    const state = cashierContext.state;
    const currencySymbol = state.availableCurrencies.find(c => c.code === ticketDetails.currency)?.symbol || '$';
    const formattedDate = moment.utc(ticketDetails.paid_at || new Date()).tz(VENEZUELA_TIMEZONE).format('DD/MM/YYYY');
    const formattedTime = moment.utc(ticketDetails.paid_at || new Date()).tz(VENEZUELA_TIMEZONE).format('hh:mm A');
    const horsesText = Array.isArray(ticketDetails.horse_numbers) ? ticketDetails.horse_numbers.map(n => `#${n}`).join(', ') : 'N/A';

    const receiptHtmlContent = `
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="utf-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Pago</title>
            <style>
                @page { margin: 0; size: 58mm auto; }
                html, body { 
                    margin: 0 !important; 
                    padding: 0 !important; 
                    background: #fff;
                    width: 100%;
                }
                .thermal-ticket {
                    font-family: 'Courier New', Courier, monospace;
                    font-size: 11px;
                    font-weight: 900 !important; 
                    color: #000;
                    width: 58mm; 
                    max-width: 100%;
                    margin: 0 auto;
                    padding: 2mm 2mm 15mm 2mm; 
                    box-sizing: border-box;
                    line-height: 1.2;
                    text-align: left;
                    overflow: hidden;
                }
                .thermal-ticket * { font-weight: 900 !important; }
            </style>
        </head>
        <body>
            <div class="thermal-ticket">
                *** PAGO PREMIO ***<br>
                ${formattedDate} - ${formattedTime}<br>
                ========================<br>
                TICKET PAGADO:${ticketDetails.id}<br>
                ========================<br>
                HIPODROMO: ${ticketDetails.track_name || 'N/A'}<br>
                CARRERA: C-${ticketDetails.race_number || 'N/A'}<br>
                ------------------------<br>
                EJEMPLAR N°${horsesText}<br>
                ------------------------<br>
                APOSTADO:${currencySymbol}${parseFloat(ticketDetails.wager_amount || ticketDetails.amount || 0).toFixed(2)}<br>
                ========================<br>
                PREMIO PAGADO:${currencySymbol}${parseFloat(ticketDetails.paid_amount).toFixed(2)} ${ticketDetails.currency || 'USD'}<br>
                ========================<br>
                <span style="font-size: 9px;">Felicidades por su premio</span><br>
                <br><br><br><br>
                . . . . . . . . . . . .
            </div>
        </body>
        </html>
    `;

    executeHybridPrint(receiptHtmlContent);
};

/**
 * 3. IMPRESIÓN DE REPORTE Z (CUADRE DE CAJA)
 */
export const printReconciliationReceipt = (reconData) => {
    const printTime = moment().tz(VENEZUELA_TIMEZONE).format('DD/MM/YYYY HH:mm');

    const receiptHtmlContent = `
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="utf-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Reporte de Caja (Z)</title>
            <style>
                /* ESTÁNDAR 58mm PARA IMPRESORAS TÉRMICAS TIPO POS-5890K */
                @page { margin: 0; size: 58mm auto; }
                html, body { 
                    margin: 0 !important; 
                    padding: 0 !important; 
                    background: #fff;
                    width: 100%;
                }
                body { 
                    font-family: 'Courier New', monospace; 
                    font-size: 12px; 
                    width: 58mm; 
                    margin: 0 auto; 
                    padding: 2mm 2mm 15mm 2mm; 
                    box-sizing: border-box; 
                    color: #000; 
                    text-align: left; 
                }
                h2, h3, h4 { margin: 4px 0; text-align: left; text-transform: uppercase; font-size: 14px; }
                p { margin: 2px 0; text-align: left; }
                .divider { border-top: 1px dashed #000; margin: 8px 0; width: 100%; }
                
                /* Filas alineadas totalmente a la izquierda */
                .row { 
                    display: block; 
                    text-align: left;
                    margin-bottom: 3px; 
                    width: 100%;
                    white-space: nowrap;
                } 
                
                .label { font-weight: normal; text-transform: uppercase; }
                .value { font-weight: bold; margin-left: 4px; }
                
                .bold { font-weight: 900; }
                .section-title { 
                    font-weight: bold; 
                    text-align: left; 
                    text-decoration: underline; 
                    margin-top: 12px; 
                    margin-bottom: 6px;
                    font-size: 13px;
                    text-transform: uppercase;
                }
                @media print { 
                    body { margin: 0; padding: 2mm; }
                }
            </style>
        </head>
        <body>
            <div class="thermal-ticket">
            <h2>TAQUILLA HÍPICA</h2>
            <h3>REPORTE DE CAJA (Z)</h3>
            <div class="divider"></div>
            
            <p>IMPRESO: ${printTime}</p>
            <p>CAJERO: ${reconData.cashierName}</p>
            <p>${reconData.dateRange.replace(/\/202\d/g, "")}</p> 
            <p>TASA: ${reconData.rate.toFixed(2)} BS/$</p>
            
            <div class="divider"></div>
            
            <div class="section-title">RES DÓLARES</div>
            <div class="row"><span class="label">CAJA INICIAL:</span><span class="value">$${reconData.initialCash.toFixed(2)}</span></div>
            <div class="row"><span class="label">(+) VENTAS:</span><span class="value">$${reconData.usd.sales.toFixed(2)}</span></div>
            <div class="row"><span class="label">(-) PAGOS:</span><span class="value">-$${reconData.usd.paid.toFixed(2)}</span></div>
            <div class="row"><span class="label">(I) ANULADOS:</span><span class="value">$${reconData.usd.voided.toFixed(2)}</span></div>
            <div class="row"><span class="label">POR PAG:</span><span class="value">$${reconData.usd.pendingAmt.toFixed(2)}</span></div>
            <div class="row bold"><span class="label">TOT CAJA:</span><span class="value">$${reconData.usd.net.toFixed(2)}</span></div>

            <div class="divider"></div>

            <div class="section-title">RES BOLÍVARES</div>
            <div class="row"><span class="label">(+) VENTAS:</span><span class="value">BS.${reconData.ves.sales.toFixed(2)}</span></div>
            <div class="row"><span class="label">(-) PAGOS:</span><span class="value">-BS.${reconData.ves.paid.toFixed(2)}</span></div>
            <div class="row"><span class="label">(I) ANULADOS:</span><span class="value">BS.${reconData.ves.voided.toFixed(2)}</span></div>
            <div class="row"><span class="label">POR PAG:</span><span class="value">BS.${reconData.ves.pendingAmt.toFixed(2)}</span></div>
            <div class="row bold"><span class="label">TOT CAJA:</span><span class="value">BS.${reconData.ves.net.toFixed(2)}</span></div>

            <div class="divider"></div>
            <div class="row bold" style="font-size: 13px;">
                <span class="label">TKTs PTE:</span>
                <span class="value">${reconData.pendingCount}</span>
            </div>
            <div class="divider"></div>

            <div class="section-title">TOTAL CONSOLIDADO</div>
            <div class="row bold" style="font-size: 14px;"><span class="label">NETO USD:</span><span class="value">$${reconData.totalNetUSD.toFixed(2)}</span></div>
            <div class="row bold" style="font-size: 14px;"><span class="label">NETO:</span><span class="value">BS.${reconData.totalNetVES.toFixed(2)}</span></div>

            <div class="divider"></div>
            <p>TKTs PROCESADOS: ${reconData.totalTickets}</p>
            <p style="margin-top:12px; font-size:10px; font-weight: bold;">-- FIN DEL REPORTE --</p>
            <br><br><br>
            . . . . . . . . . . . .
            </div>
        </body>
        </html>
    `;

    executeHybridPrint(receiptHtmlContent);
};